<template>
    <div class="voice-configuration">
        <div class="voice-button-group">
            <!-- Ses Seçici Butonu -->
            <div class="voice-selector-btn" @click="openVoiceSelector">
                <div class="btn-content">
                    <div class="voice-info">
                        <i class="material-icons voice-icon">music_note</i>
                        <div class="voice-name" v-if="selectedVoice">{{ selectedVoice.voice_name }}</div>
                        <div class="voice-name" v-else>Ses Seçin</div>
                    </div>
                    <i class="material-icons">expand_more</i>
                </div>
            </div>

            <!-- Ses Ayarları Butonu -->
            <a-popover
                placement="topLeft"
                :visible="isSettingsVisible"
                @visibleChange="handleSettingsVisibleChange"
                :trigger="['click']"
                overlayClassName="voice-settings-popover"
            >
                <template slot="content">
                    <VoiceSettings
                        :voiceModel="voiceModel"
                        :voiceTemperature="voiceTemperature"
                        :voiceSpeed="voiceSpeed"
                        :voiceVolume="voiceVolume"
                        @update="handleSettingsUpdate"
                        @close="isSettingsVisible = false"
                    />
                </template>
                <div class="voice-settings-btn">
                    <i class="material-icons">settings</i>
                </div>
            </a-popover>
        </div>

        <!-- Ses Seçici Modal -->
        <Modal2
            v-if="isVoiceSelectorVisible"
            title="Ses Seçimi"
            :showFooter="false"
            @cancel="isVoiceSelectorVisible = false"
            className="voice-selector-modal"
            large
        >
            <VoiceSelector :selectedVoice="selectedVoice" @select="handleVoiceSelect" />
        </Modal2>
    </div>
</template>

<script>
import Modal2 from "../../../../../components/common/Modal2.vue";
import VoiceSelector from "./VoiceSelector.vue";
import VoiceSettings from "./VoiceSettings.vue";
import PermissionController from "../../../../../components/permission-controller/PermissionController";

export default {
    name: "VoiceConfiguration",
    components: {
        Modal2,
        VoiceSelector,
        VoiceSettings,
    },
    props: {
        agent: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isVoiceSelectorVisible: false,
            isSettingsVisible: false,
            selectedVoice: null,
            voiceModel: "eleven_multilingual_v2", // Varsayılan değer
            voiceTemperature: 1.0,
            voiceSpeed: 1.0,
            voiceVolume: 1.0,
        };
    },
    watch: {
        agent: {
            immediate: true,
            handler(newAgent) {
                if (newAgent) {
                    this.voiceModel = newAgent.voice_model || "eleven_multilingual_v2";
                    this.voiceTemperature = newAgent.voice_temperature || 1.0;
                    this.voiceSpeed = newAgent.voice_speed || 1.0;
                    this.voiceVolume = newAgent.volume || 1.0;

                    // Eğer agent'in voice_id'si varsa, bu sesi yüklemeliyiz
                    if (newAgent.voice_id) {
                        this.loadSelectedVoice(newAgent.voice_id);
                    }
                }
            },
            deep: true,
        },
    },
    methods: {
        openVoiceSelector() {
            if(!PermissionController.check(["voice-agent.update"])) {
                PermissionController.sendError("Bu işlemi gerçekleştirmek için yeterli izniniz yok.");
                return;
            }
            this.isVoiceSelectorVisible = true;
        },
        handleSettingsVisibleChange(visible) {
            this.isSettingsVisible = visible;
        },
        handleVoiceSelect(voice) {
            this.selectedVoice = voice;
            this.isVoiceSelectorVisible = false;

            // Agent'i güncelle
            this.$emit("update", { voice_id: voice.voice_id });
        },
        handleSettingsUpdate(settings) {
            // Ayarları güncelle
            this.voiceModel = settings.voiceModel;
            this.voiceTemperature = settings.voiceTemperature;
            this.voiceSpeed = settings.voiceSpeed;
            this.voiceVolume = settings.voiceVolume;

            // Agent'i güncelle
            this.$emit("update", {
                voice_model: settings.voiceModel,
                voice_temperature: settings.voiceTemperature,
                voice_speed: settings.voiceSpeed,
                volume: settings.voiceVolume,
            });
        },
        async loadSelectedVoice(voiceId) {
            try {
                const voice = await this.$store.dispatch("voiceAgent/getVoice", voiceId);
                if (voice) {
                    this.selectedVoice = voice;
                }
            } catch (error) {
                console.error("Ses yüklenirken hata oluştu:", error);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.voice-configuration {
    .voice-button-group {
        display: flex;
        border: 1px solid #22272d;
        border-radius: 4px;
        overflow: hidden;

        .voice-selector-btn {
            flex: 1;
            padding: 8px 12px;
            cursor: pointer;
            background-color: #fff;
            border-right: 1px solid #22272d;

            &:hover {
                background-color: #f5f5f5;
            }

            .btn-content {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .voice-info {
                    display: flex;
                    align-items: center;
                    gap: 6px;

                    .voice-icon {
                        color: #22272d;
                        font-size: 18px;
                    }

                    .voice-name {
                        font-weight: 500;
                    }
                }
            }
        }

        .voice-settings-btn {
            padding: 8px 12px;
            cursor: pointer;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
                background-color: #f5f5f5;
            }

            .material-icons {
                font-size: 20px;
                color: #595959;
            }
        }
    }
}

:deep(.voice-settings-popover) {
    min-width: 300px;
}

:deep(.voice-selector-modal) {
    .ant-modal-body {
        padding: 0;
    }
}
</style>
